// @flow
import * as React from 'react';
import Button from '@liveauctioneers/caterwaul-components/lib/Button/Button';
import classNames from 'classnames';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle';
import { faEnvelope } from '@fortawesome/pro-solid-svg-icons/faEnvelope';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import isEqual from 'react-fast-compare';
import OverlayTrigger from '../../components/Overlay/OverlayTrigger';
import Popover from 'react-bootstrap/lib/Popover';
import ShouldLogInContainer from '../../components/ShouldLogIn/ShouldLogInContainer';
import styles from './SaveSearch.module.scss';
import Throbber from '@liveauctioneers/caterwaul-components/lib/Throbber/Throbber';

type SaveSearchCheckState = {
    error: boolean,
    isSavedSearch: boolean,
    savedSearchId: number,
    success: boolean,
};

type SaveSearchState = {
    error: boolean,
    submitted: boolean,
    success: boolean,
};

type Props = {
    className?: string,
    deleteSavedSearch: Function,
    primary: boolean,
    saveSearchCheckState: SaveSearchCheckState,
    saveSearchState: SaveSearchState,
    small?: boolean,
    submitSaveSearch: Function,
    tooltipMessage?: React.Node | string,
};

export default class SaveSearch extends React.Component<Props> {
    shouldComponentUpdate = (nextProps: Props) => !isEqual(this.props, nextProps);

    render() {
        const { className, primary, saveSearchState, saveSearchCheckState, small, tooltipMessage } = this.props;

        const { submitted } = saveSearchState;
        const { isSavedSearch } = saveSearchCheckState;

        const popover = (
            <Popover id="popover" bsClass="popover">
                {tooltipMessage}
            </Popover>
        );
        const nonSaveSearchBtn = (
            <Button
                primary
                secondary={!primary}
                className={classNames(className, { [styles['button-save']]: !primary })}
            >
                {!submitted && <FontAwesomeIcon icon={faEnvelope} className={styles.icon} />}
                {submitted ? <Throbber colorWhite /> : <FormattedMessage id="save_search_save" />}
            </Button>
        );

        const nonSaveSearchBtnWTrigger = (
            <OverlayTrigger rootClose placement="bottom" overlay={popover}>
                {nonSaveSearchBtn}
            </OverlayTrigger>
        );

        const classes = classNames(className, {
            [styles['button-saved']]: primary,
            [styles['search-page-button-saved']]: !primary,
        });

        return (
            <span>
                {!isSavedSearch && (
                    <ShouldLogInContainer requireLogin runFunction={this.props.submitSaveSearch}>
                        {tooltipMessage ? nonSaveSearchBtnWTrigger : nonSaveSearchBtn}
                    </ShouldLogInContainer>
                )}
                {isSavedSearch && (
                    <ShouldLogInContainer requireLogin runFunction={this.props.deleteSavedSearch}>
                        <Button small={small} className={classes}>
                            {!submitted && <FontAwesomeIcon icon={faCheckCircle} className={styles.icon} />}
                            {submitted ? <Throbber colorWhite /> : <FormattedMessage id="save_search_saved" />}
                        </Button>
                    </ShouldLogInContainer>
                )}
            </span>
        );
    }
}
